var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('delayed-input',{attrs:{"query":_vm.query,"loading":_vm.loading,"placeholder":_vm.placeholder},on:{"onChange":_vm.checkQuery}})}
var staticRenderFns = []

export { render, staticRenderFns }